import { render, staticRenderFns } from "./DocumentList_backup.vue?vue&type=template&id=9b00eb0e&"
import script from "./DocumentList_backup.vue?vue&type=script&lang=js&"
export * from "./DocumentList_backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports